export default __webpack_public_path__ + "static/simple-bubble-c5710b18df487442c2d240ed4b4d40c0.png";